module.exports = __webpack_public_path__ + "img/ico_help_white.a30fa8dd.svg";